import React, { useReducer } from 'react';
import { ApplicationContainer } from './universe/organisms/ApplicationContainer';
import { AuthService, ModalContext, ModalDialog, modalReducer } from '@vfpf/vfpf-shared';
import { Routes } from './Routes';
import { userApi } from './api/apiClient';

export const App: React.FC = () => {
  const modalState = useReducer(modalReducer, {});

  return (
    <ModalContext.Provider value={modalState}>
      <AuthService userApi={userApi.userGetUser}>
        <ApplicationContainer>
          <Routes />
          <ModalDialog />
        </ApplicationContainer>
      </AuthService>
    </ModalContext.Provider>
  );
};
